import ModalComponent from "../../ModalComponent";
import Form from "../../Form";
import UPDATE_ORGANIZATION from "../../../api/mutations/updateOrganization";
import EVENTS from "../../../api/queries/events";
import ORGANIZATION from "../../../api/queries/organization";
import ROLE_TYPES from "../../../api/queries/roleTypes";
import { useAppState } from "../../../utils/appState";
import moment from "moment";

function CreateEventRole({ organizationId }) {
  const [, setAppState] = useAppState();
  return (
    <ModalComponent>
      {(wrapperRef) => (
        <div ref={wrapperRef} className="modal-form">
          <Form
            mutation={UPDATE_ORGANIZATION}
            initialState={{
              type: "",
              event: "",
            }}
            fields={[
              {
                label: "Event",
                type: "select",
                key: "event",
                query: EVENTS,
                items: (d) => d.events,
                optionLabel: (i) => i.name,
              },
              {
                label: "Role",
                type: "select",
                key: "type",
                query: ROLE_TYPES,
                items: (d) => d.roleTypes,
                optionLabel: (i) => i.name,
              },
            ]}
            update={(cache, { data: { updateOrganization } }) => {
              const q = cache.readQuery({
                query: ORGANIZATION,
                variables: { id: organizationId },
              });
              cache.writeQuery({
                query: ORGANIZATION,
                variables: { id: organizationId },
                data: {
                  organization: {
                    ...q.organization,
                    eventRoles: updateOrganization.eventRoles,
                  },
                },
              });
              setAppState({ modal: false });
            }}
            vars={(s) => {
              const v = {
                where: { id: organizationId },
                data: {
                  eventRoles: {
                    create: {
                      event: { connect: { id: s.event } },
                      type: { connect: { id: s.type } },
                    },
                  },
                },
              };

              console.log(v);
              return v;
            }}
            title={"New Event Role"}
          />
        </div>
      )}
    </ModalComponent>
  );
}

export default CreateEventRole;
